import { createContext, useContext, ReactNode } from 'react';

interface CompanyContextValue {
  companyId: string;
  // The store's public route (whop.com/<route>, and our /g/<route>/… links);
  // null when unknown.
  companyRoute: string | null;
}

const CompanyContext = createContext<CompanyContextValue | null>(null);

function useCompanyContext(): CompanyContextValue {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompanyId must be used within CompanyProvider');
  }
  return context;
}

export function useCompanyId(): string {
  return useCompanyContext().companyId;
}

export function useCompanyRoute(): string | null {
  return useCompanyContext().companyRoute;
}

interface CompanyProviderProps {
  companyId: string;
  companyRoute?: string | null;
  children: ReactNode;
}

export function CompanyProvider({ companyId, companyRoute = null, children }: CompanyProviderProps) {
  return (
    <CompanyContext.Provider value={{ companyId, companyRoute }}>
      {children}
    </CompanyContext.Provider>
  );
}
